import { createFrontendModule } from '@backstage/frontend-plugin-api';
import { IconComponent } from '@backstage/core-plugin-api';
import { AppIcons } from '../utils/icons';
import scaffolderPlugin from '@backstage/plugin-scaffolder/alpha';

const appviaScaffolderNavItem = scaffolderPlugin
  .getExtension('nav-item:scaffolder')
  .override({
    params: {
      icon: AppIcons.scaffolder as IconComponent,
    },
  });

export const appviaScaffolderModule = createFrontendModule({
  pluginId: 'scaffolder',
  extensions: [appviaScaffolderNavItem],
});
